<ng-container *ngIf="loading">
  <app-loader *ngIf="loading"></app-loader>
  <div class="text-center">
    Please wait while the workflow is analyzed for configuration choices...
  </div>
</ng-container>

<ng-container *ngIf="!loading">
  <!-- Start Code added by Sanchit on 06/17/2026 -->
  <!-- Changed from h1 to h4 to match the text size as per figma -->
  <h4>
    {{
      config.action == WorkflowConfigurationSaveAction.Import
        ? 'Import'
        : 'Copy'
    }}
    {{ sourceWorkflowName }}
  </h4>

  <div class="container mt-4" *ngIf="blockers.length > 0">
    <h6>
      <strong>
        <ng-container *ngTemplateOutlet="blockersTmpl"></ng-container>
      </strong>
    </h6>
  </div>
  <div class="container mt-4">
    <div id="accordion">
      <!-- Section 0: Workflow Name and Description -->
      <div class="card" *ngIf="sections[0].enabled">
        <div class="card-header" id="headingWorkflowSettings">
          <div class="d-flex justify-content-between">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                [attr.aria-expanded]="expandedSectionIndex === 0"
                (click)="expandedSectionIndex = 0"
              >
                {{ sections[0].label }}
              </button>
            </h5>
            <span
              *ngIf="sections[0].completed"
              class="text-success ml-2"
              title="Completed"
              >&#10003;</span
            >
            <span
              *ngIf="!sections[0].completed"
              class="text-muted ml-2"
              title="Not completed"
              >&#9711;</span
            >
          </div>
        </div>
        <div
          [ngClass]="{
            collapse: expandedSectionIndex !== 0,
            show: expandedSectionIndex === 0
          }"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div [formGroup]="workflowSettingsForm">
                  <div class="form-group">
                    <wm-common-textfield
                      [(ngModel)]="config.workflowUpdates.name"
                      formControlName="workflowName"
                      [data]="{
                        label: 'Workflow Name',
                        placeholder: 'Enter workflow name',
                      }">
                    </wm-common-textfield>

                    <wm-control-message
                      [control]="workflowSettingsForm.controls['workflowName']">
                    </wm-control-message>
                  </div>
                  <div class="form-group">
                    <wm-common-textfield
                      [(ngModel)]="config.workflowUpdates.description"
                      formControlName="description"
                      [data]="{
                        label: 'Description',
                        placeholder: 'Enter description'
                      }"
                      (valueChange)="onDescChange($event)">
                    </wm-common-textfield>

                    <wm-control-message
                      [control]="workflowSettingsForm.controls['description']">
                    </wm-control-message>
                  </div>
                </div>
              </div>
            </div>
            <div class="import-workflow-modal-actions">
              <div class="import-workflow-modal-gray-btn">
                <wm-common-button
                  (click)="isSaving = true; saveForLater()"
                  [disabled]="isSaving"
                  [data]="{
                    text: 'Save for Later',
                    type: 'secondary'
                  }">
                </wm-common-button>
              </div>

              <div class="import-workflow-modal-blue-btn">
                <wm-common-button
                  (click)="
                    isSaving = true;
                    config.workflowUpdates.completed = true;
                    nextSection()
                  "
                  [disabled]="isSaving || workflowSettingsForm.invalid"
                  [data]="{
                    text: 'Next',
                    type: 'primary'
                  }">
                </wm-common-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 1: Map Roles -->
      <div class="card" *ngIf="sections[1].enabled">
        <div class="card-header" id="headingRoles">
          <div class="d-flex justify-content-between">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                [attr.aria-expanded]="expandedSectionIndex === 1"
                (click)="expandedSectionIndex = 1"
              >
                {{ sections[1].label }}
              </button>
            </h5>
            <span
              *ngIf="sections[1].completed"
              class="text-success ml-2"
              title="Completed"
              >&#10003;</span
            >
            <span
              *ngIf="!sections[1].completed"
              class="text-muted ml-2"
              title="Not completed"
              >&#9711;</span
            >
          </div>
        </div>
        <div
          [ngClass]="{
            collapse: expandedSectionIndex !== 1,
            show: expandedSectionIndex === 1
          }"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group" [formGroup]="roleMappingsForm">
                  <div *ngFor="let roleMapping of config.roleMappings.mappings">
                    <label
                      >{{ roleMapping.sourceRoleName }} changes to:
                      <span class="text-danger">*</span></label
                    >
                    <select
                      class="form-control"
                      [formControlName]="roleMapping.sourceRoleId"
                      [(ngModel)]="roleMapping.targetRoleId"
                    >
                      <option
                        *ngFor="let tRole of targetResources.responsibleRoles"
                        [ngValue]="tRole.id"
                      >
                        {{ tRole.name }}
                      </option>
                      <option [ngValue]="null"
                        >&nbsp; +
                        <strong>Add Role to Destination</strong></option
                      >
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-raised"
                [disabled]="isSaving"
                (click)="isSaving = true; saveForLater()"
              >
                Save for Later
              </button>
              <button
                class="btn btn-primary btn-raised"
                [disabled]="isSaving"
                (click)="
                  isSaving = true;
                  config.roleMappings.completed = true;
                  nextSection()
                "
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 2: Map Custom Lists and Items -->
      <div class="card" *ngIf="sections[2].enabled">
        <div class="card-header" id="headingCustomLists">
          <div class="d-flex justify-content-between">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                [attr.aria-expanded]="expandedSectionIndex === 2"
                (click)="expandedSectionIndex = 2"
              >
                {{ sections[2].label }}
              </button>
            </h5>
            <span
              *ngIf="sections[2].completed"
              class="text-success ml-2"
              title="Completed"
              >&#10003;</span
            >
            <span
              *ngIf="!sections[2].completed"
              class="text-muted ml-2"
              title="Not completed"
              >&#9711;</span
            >
          </div>
        </div>
        <div
          [ngClass]="{
            collapse: expandedSectionIndex !== 2,
            show: expandedSectionIndex === 2
          }"
        >
          <div class="card-body" [formGroup]="customListMappingsForm">
            <div
              *ngFor="
                let customListMapping of config.customListMappings.mappings
              "
              class="mb-4 border p-3 rounded"
            >
              <div *ngIf="!customListMapping.sourceRoleName" class="row">
                <div class="col-md-4">
                  <h6>{{ customListMapping.sourceListName }}</h6>
                </div>
                <div class="col-md-4">
                  <label>
                    Changes to Target List:
                    <span class="text-danger">*</span>
                  </label>
                  <select
                    class="form-control mb-2"
                    [(ngModel)]="customListMapping.targetListId"
                    [formControlName]="customListMapping.sourceListId"
                    (ngModelChange)="
                      defaultTargetListItems(
                        customListMapping.sourceListId,
                        customListMapping.targetListId
                      )
                    "
                  >
                    <option
                      *ngFor="let tList of targetCustomLists"
                      [ngValue]="tList.id"
                    >
                      {{ tList.name }}
                    </option>
                    <option [ngValue]="null">
                      &nbsp; +
                      <strong>
                        Add Custom List to Destination
                      </strong>
                    </option>
                  </select>
                </div>
                <div
                  class="col-md-4"
                  *ngIf="customListMapping.targetListId != null"
                >
                  <h6>Configure Items</h6>
                  <div
                    *ngFor="let itemMapping of customListMapping.itemMappings"
                    class="mb-2"
                  >
                    <label
                      >{{ itemMapping.sourceItem.value }} changes to:
                      <span class="text-danger">*</span></label
                    >
                    <select
                      class="form-control"
                      [(ngModel)]="itemMapping.targetItemId"
                      [formGroupName]="customListMapping.sourceListId"
                      [formControlName]="itemMapping.sourceItem.id"
                      [disabled]="customListMapping.targetListId == null"
                    >
                      <option
                        *ngFor="
                          let tItem of getTargetCustomListItems(
                            customListMapping.targetListId
                          )
                        "
                        [ngValue]="tItem.id"
                      >
                        {{ tItem.value }}
                      </option>
                      <option [ngValue]="null">
                        &nbsp; +
                        <strong>
                          Add {{ itemMapping.sourceItem.value }} to
                          {{
                            getTargetCustomListById(
                              customListMapping.targetListId
                            )?.name
                          }}
                        </strong>
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div *ngIf="customListMapping.sourceRoleName" class="row">
                <div class="col-md-4">
                  <h6>
                    Members of the {{ customListMapping.sourceRoleName }} role
                  </h6>
                </div>
                <div class="col-md-4">
                  <label>
                    Changes to Target List:
                    <span class="text-danger">*</span>
                  </label>
                  <select
                    class="form-control mb-2"
                    [(ngModel)]="customListMapping.targetListId"
                    [formControlName]="customListMapping.sourceListId"
                  >
                    <option
                      *ngFor="let tList of targetRoleMemberCustomLists"
                      [ngValue]="tList.id"
                    >
                      {{ tList.name }}
                    </option>
                    <option [ngValue]="null">
                      &nbsp; +
                      <strong>
                        Add Custom List to Destination
                      </strong>
                    </option>
                  </select>
                </div>


                <div class="col-md-4" *ngIf="!customListMapping.targetListId">
                  <div *ngIf="targetJurisdictionId">
                    <label
                      >Changes to Target Role:
                      <span class="text-danger">*</span></label
                    >
                    <div [formGroup]="customListMappingsForm">
                      <select
                        class="form-control mb-2"
                        [(ngModel)]="customListMapping.targetRoleId"
                        [formControlName]="customListMapping.sourceListId"
                      >
                        <option
                          *ngFor="
                            let tClRole of targetResources.rolesForCustomLists
                          "
                          [ngValue]="tClRole.id"
                        >
                          {{ tClRole.name }}
                        </option>
                      </select>
                      <wm-control-message
                        [control]="
                          customListMappingsForm.controls[
                            customListMapping.sourceListId
                          ]
                        "
                      ></wm-control-message>
                    </div>
                  </div>
                  <div *ngIf="!targetJurisdictionId" class="text-warning">
                    <strong>
                      Role Member Custom Lists cannot be used in Template
                      Library workflows, so any List Data Entities that use this
                      as a List Source will default to having no List Source.
                    </strong>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-raised"
                [disabled]="isSaving"
                (click)="isSaving = true; saveForLater()"
              >
                Save for Later
              </button>
              <button
                class="btn btn-primary btn-raised"
                [disabled]="
                  isSaving || (!isGlobalAdmin && customListMappingsForm.invalid)
                "
                (click)="
                  isSaving = true;
                  config.customListMappings.completed = true;
                  nextSection()
                "
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 3: Map Fee Recipients -->
      <div class="card" *ngIf="sections[3].enabled">
        <div class="card-header" id="headingfeeRecipients">
          <div class="d-flex justify-content-between">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                [attr.aria-expanded]="expandedSectionIndex === 3"
                (click)="expandedSectionIndex = 3"
              >
                {{ sections[3].label }}
              </button>
            </h5>
            <span
              *ngIf="sections[3].completed"
              class="text-success ml-2"
              title="Completed"
              >&#10003;</span
            >
            <span
              *ngIf="!sections[3].completed"
              class="text-muted ml-2"
              title="Not completed"
              >&#9711;</span
            >
          </div>
        </div>
        <div
          [ngClass]="{
            collapse: expandedSectionIndex !== 3,
            show: expandedSectionIndex === 3
          }"
        >
          <div class="card-body">
            <div *ngIf="config.feeUpdates.completed" class="text-warning mb-3">
              "Review & Edit Workflow Fees" has already been completed, but
              changes made here to Fee Recipients will be applied to "Review &
              Edit Workflow Fees" and "Review & Edit Workflow Fees" will need to
              be reviewed and completed again.
            </div>
            <div class="row">
              <div class="col-md-12" [formGroup]="feeRecipientMappingsForm">
                <div
                  *ngFor="
                    let recipientMapping of config.feeRecipientMappings.mappings
                  "
                >
                  <div class="row">
                    <div class="col-md-4">
                      <h6>{{ recipientMapping.sourceValue }}</h6>
                    </div>
                    <div class="col-md-4">
                      <div class="switch">
                        <label>
                          <input
                            type="checkbox"
                            [formControlName]="
                              recipientMapping.sourceId + '_ignored'
                            "
                            [(ngModel)]="recipientMapping.isIgnored"
                          />
                          Don't use this Fee Recipient
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <ng-container *ngIf="!recipientMapping.isIgnored">
                        <label
                          >{{ recipientMapping.sourceValue }} changes to:
                          <span class="text-danger">*</span></label
                        >
                        <select
                          class="form-control mb-2"
                          [formControlName]="recipientMapping.sourceId"
                          [(ngModel)]="recipientMapping.targetId"
                        >
                          <option
                            *ngFor="
                              let tRecipient of targetResources.feeRecipients
                            "
                            [ngValue]="tRecipient.id"
                          >
                            {{ tRecipient.value }}
                          </option>
                          <option [ngValue]="null">
                            &nbsp; +
                            <strong>
                              Add Fee Recipient to Destination
                            </strong>
                          </option>
                        </select>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-raised"
                [disabled]="isSaving"
                (click)="isSaving = true; saveForLater()"
              >
                Save for Later
              </button>
              <button
                class="btn btn-primary btn-raised"
                [disabled]="isSaving"
                (click)="
                  isSaving = true;
                  config.feeRecipientMappings.completed = true;
                  updateFeeRecipientUsage();
                  nextSection()
                "
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 4: Review/Edit Fees -->
      <div class="card" *ngIf="sections[4].enabled">
        <div class="card-header" id="headingFees">
          <div class="d-flex justify-content-between">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                [attr.aria-expanded]="expandedSectionIndex === 4"
                (click)="expandedSectionIndex = 4"
              >
                {{ sections[4].label }}
              </button>
            </h5>
            <span
              *ngIf="sections[4].completed"
              class="text-success ml-2"
              title="Completed"
              >&#10003;</span
            >
            <span
              *ngIf="!sections[4].completed"
              class="text-muted ml-2"
              title="Not completed"
              >&#9711;</span
            >
          </div>
        </div>
        <div
          [ngClass]="{
            collapse: expandedSectionIndex !== 4,
            show: expandedSectionIndex === 4
          }"
        >
          <div class="card-body">
            <div
              class="mb-4 border p-3 rounded"
              *ngFor="let feeDE of config.feeUpdates.feeDataEntities"
            >
              <div class="row">
                <div class="col-md-12">
                  <h3>{{ feeDE.label }}</h3>
                </div>
                <div class="col-md-12">
                  <wm-fee-data-entity-editor
                    *ngIf="expandedSectionIndex === 4"
                    [form]="feeUpdatesForm.controls[feeDE.templateCode]"
                    [dataEntity]="feeDE"
                    [activity]="feeDE.parentActivitySurrogate"
                    [workflowVersionId]="config.sourceWorkflowVersionId"
                    [targetClientId]="targetJurisdictionId"
                    [globalTarget]="!targetJurisdictionId"
                    [showManageFeeRecipientsLink]="false"
                  ></wm-fee-data-entity-editor>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-raised"
                [disabled]="isSaving"
                (click)="isSaving = true; saveForLater()"
              >
                Save for Later
              </button>
              <button
                class="btn btn-primary btn-raised"
                [disabled]="
                  isSaving || (!isGlobalAdmin && feeUpdatesForm.invalid)
                "
                (click)="
                  isSaving = true;
                  config.feeUpdates.completed = true;
                  nextSection()
                "
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 5: Review/Edit Email Footers -->
      <div class="card" *ngIf="sections[5].enabled">
        <div class="card-header" id="headingEmailFooters">
          <div class="d-flex justify-content-between">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                [attr.aria-expanded]="expandedSectionIndex === 5"
                (click)="expandedSectionIndex = 5"
              >
                {{ sections[5].label }}
              </button>
            </h5>
            <span
              *ngIf="sections[5].completed"
              class="text-success ml-2"
              title="Completed"
              >&#10003;</span
            >
            <span
              *ngIf="!sections[5].completed"
              class="text-muted ml-2"
              title="Not completed"
              >&#9711;</span
            >
          </div>
        </div>
        <div
          [ngClass]="{
            collapse: expandedSectionIndex !== 5,
            show: expandedSectionIndex === 5
          }"
        >
          <div class="card-body" [formGroup]="emailFooterMappingsForm">
            <div
              *ngIf="config.emailUpdates.completed"
              class="text-warning mb-3"
            >
              "Review & Edit Workflow Emails" has already been completed, but
              changes made here to Email Footers will be applied to "Review &
              Edit Workflow Emails" and "Review & Edit Workflow Emails" will
              need to be reviewed and completed again.
            </div>
            <div
              class="mb-4 border p-4 rounded"
              *ngFor="
                let emailFooterMapping of config.emailFooterMappings.mappings
              "
            >
              <div
                class="row"
                [formGroupName]="emailFooterMapping.sourceEmailFooter.id"
              >
                <div class="col-md-4">
                  <h6>{{ emailFooterMapping.sourceEmailFooter.label }}</h6>
                </div>
                <div class="col-md-4">
                  <div class="switch">
                    <label>
                      <input
                        type="checkbox"
                        formControlName="isIgnored"
                        (ngModelChange)="emailFooterMapping.isIgnored = $event"
                        [ngModel]="emailFooterMapping.isIgnored"
                      />
                      Don't use this Email Footer
                    </label>
                  </div>
                </div>
                <div class="col-md-4">
                  <ng-container *ngIf="!emailFooterMapping.isIgnored">
                    <label
                      >{{ emailFooterMapping.sourceEmailFooter.label }} changes
                      to: <span class="text-danger">*</span></label
                    >
                    <select
                      class="form-control mb-2"
                      formControlName="targetId"
                      (ngModelChange)="emailFooterMapping.targetId = $event"
                      [ngModel]="emailFooterMapping.targetId"
                      (change)="
                        resetTargetEmailFooterContent(emailFooterMapping)
                      "
                    >
                      <option
                        *ngFor="let tFooter of targetResources.emailFooters"
                        [ngValue]="tFooter.id"
                      >
                        {{ tFooter.label }}
                      </option>
                      <option [ngValue]="null">
                        &nbsp; +
                        <strong>
                          Add Email Footer to Destination
                        </strong>
                      </option>
                    </select>
                  </ng-container>
                </div>
              </div>
              <div
                class="row"
                *ngIf="
                  !emailFooterMapping.targetId && !emailFooterMapping.isIgnored
                "
              >
                <div class="col-md-12">
                  <label class="bmd-label-floating p-2" for="htmlContent"
                    >Edit Footer Content</label
                  >
                  <wm-email-footer-content-editor
                    [emailFooterId]="emailFooterMapping.sourceEmailFooter.id"
                    [emailFooterHtmlContent]="
                      emailFooterMapping.targetEmailFooterContent
                    "
                    [form]="
                      emailFooterMappingsForm.controls[
                        emailFooterMapping.sourceEmailFooter.id
                      ]
                    "
                    (contentEdited)="
                      updateTargetEmailFooterContent(
                        $event,
                        emailFooterMapping.sourceEmailFooter.id
                      )
                    "
                  ></wm-email-footer-content-editor>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-raised"
                [disabled]="isSaving"
                (click)="isSaving = true; saveForLater()"
              >
                Save for Later
              </button>
              <button
                class="btn btn-primary btn-raised"
                [disabled]="
                  isSaving ||
                  (!isGlobalAdmin && emailFooterMappingsForm.invalid)
                "
                (click)="
                  isSaving = true;
                  config.emailFooterMappings.completed = true;
                  updateEmailFooterUsage();
                  nextSection()
                "
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 6: Review/Edit Emails -->
      <div class="card" *ngIf="sections[6].enabled">
        <div class="card-header" id="headingEmails">
          <div class="d-flex justify-content-between">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                [attr.aria-expanded]="expandedSectionIndex === 6"
                (click)="expandedSectionIndex = 6"
              >
                {{ sections[6].label }}
              </button>
            </h5>
            <span
              *ngIf="sections[6].completed"
              class="text-success ml-2"
              title="Completed"
              >&#10003;</span
            >
            <span
              *ngIf="!sections[6].completed"
              class="text-muted ml-2"
              title="Not completed"
              >&#9711;</span
            >
          </div>
        </div>
        <div
          [ngClass]="{
            collapse: expandedSectionIndex !== 6,
            show: expandedSectionIndex === 6
          }"
        >
          <div class="card-body">
            <div
              class="mb-4"
              *ngFor="let emailActivity of config.emailUpdates.emailActivities; let idx = index"
            >
              <div id="emailAccordion">
                <div class="card" *ngIf="emailSections[idx].enabled">
                  <div class="card-header" id="headingEmailActivity">
                    <div class="d-flex justify-content-between">
                      <h5 class="mb-0">
                        <button
                          class="btn btn-link"
                          [attr.aria-expanded]="expandedEmailSectionIndex === idx"
                          (click)="expandedEmailSectionIndex = idx"
                        >
                          {{ emailSections[idx].label }}
                        </button>
                      </h5>
                      <span
                        *ngIf="emailSections[idx].completed"
                        class="text-success ml-2"
                        title="Completed"
                        >&#10003;</span
                      >
                      <span
                        *ngIf="!emailSections[idx].completed"
                        class="text-muted ml-2"
                        title="Not completed"
                        >&#9711;</span
                      >
                    </div>
                  </div>
                  <div
                    [ngClass]="{
                      collapse: expandedEmailSectionIndex !== idx,
                      show: expandedEmailSectionIndex === idx
                    }"
                  >
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <h3>
                            {{ emailActivity.model.screenName }}

                            <a
                              target="_blank"
                              [routerLink]="[
                                '/admin/workflow-builder/readonly',
                                emailActivity.workflowId,
                                config.sourceWorkflowVersionId
                              ]"
                              [queryParams]="{ activityId: emailActivity.id }"
                            >
                              <button
                                class="btn btn-sm btn-raised btn-primary float-right"
                              >
                                View in Design
                              </button>
                            </a>
                          </h3>
                        </div>
                        <div class="col-md-12 mt-3">
                          <wm-email-activity-editor
                            #emailActivityEditors
                            *ngIf="expandedSectionIndex === 6 && expandedEmailSectionIndex === idx"
                            [workflowVersionId]="config.sourceWorkflowVersionId"
                            [form]="emailUpdatesForm.controls[emailActivity.id]"
                            [activity]="emailActivity"
                            [viewInModal]="false"
                            [loadFull]="true"
                            [showEmailFooterManagementLink]="false"
                            [hideHeader]="true"
                            [targetClientId]="targetJurisdictionId"
                            [globalTarget]="!targetJurisdictionId"
                          ></wm-email-activity-editor>
                        </div>
                      </div>

                      <div class="d-flex justify-content-between">
                        <button
                          class="btn btn-primary btn-raised"
                          [disabled]="!isGlobalAdmin && emailUpdatesForm.controls[emailActivity.id].invalid"
                          (click)="nextEmailSection()"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-raised"
                [disabled]="isSaving"
                (click)="isSaving = true; saveForLater()"
              >
                Save for Later
              </button>
              <button
                class="btn btn-primary btn-raised"
                [disabled]="
                  isSaving
                  ||
                  (
                    !isGlobalAdmin
                    &&
                    (
                      emailUpdatesForm.invalid
                      || !allEmailSectionsCompleted
                    )
                  )
                "
                (click)="
                  isSaving = true;
                  config.emailUpdates.completed = true;
                  nextSection()
                "
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 7: Review/Edit Print Tempaltes -->
      <div class="card" *ngIf="sections[7].enabled">
        <div class="card-header" id="headingPrintTemplates">
          <div class="d-flex justify-content-between">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                [attr.aria-expanded]="expandedSectionIndex === 7"
                (click)="expandedSectionIndex = 7"
              >
                {{ sections[7].label }}
              </button>
            </h5>
            <span
              *ngIf="sections[7].completed"
              class="text-success ml-2"
              title="Completed"
              >&#10003;</span
            >
            <span
              *ngIf="!sections[7].completed"
              class="text-muted ml-2"
              title="Not completed"
              >&#9711;</span
            >
          </div>
        </div>
        <div
          [ngClass]="{
            collapse: expandedSectionIndex !== 7,
            show: expandedSectionIndex === 7
          }"
        >
          <div class="card-body">
            <div
              class="mb-4 border p-5 rounded"
              *ngFor="
                let printTemplateActivity of this.config.printTemplateUpdates
                  .printTemplateActivities
              "
            >
              <div class="row">
                <div class="col-md-12">
                  <h4>{{ printTemplateActivity.model.screenName }}</h4>
                </div>
                <div class="col-md-12">
                  <wm-print-template-activity-editor
                    *ngIf="expandedSectionIndex === 7"
                    [workflowVersionId]="config.sourceWorkflowVersionId"
                    [activity]="printTemplateActivity"
                    [form]="
                      printTemplateUpdatesForm.controls[
                        printTemplateActivity.id
                      ]
                    "
                  ></wm-print-template-activity-editor>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-raised"
                [disabled]="isSaving"
                (click)="isSaving = true; saveForLater()"
              >
                Save for Later
              </button>
              <button
                class="btn btn-primary btn-raised"
                [disabled]="
                  isSaving ||
                  (!isGlobalAdmin && printTemplateUpdatesForm.invalid)
                "
                (click)="
                  isSaving = true;
                  config.printTemplateUpdates.completed = true;
                  nextSection()
                "
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 8: Review/Edit Select Contractor Activities / Data Entities -->
      <div class="card" *ngIf="sections[8].enabled">
        <div class="card-header" id="headingPrintTemplates">
          <div class="d-flex justify-content-between">
            <h6 class="mb-0">
              <button
                class="btn btn-link"
                [attr.aria-expanded]="expandedSectionIndex === 8"
                (click)="expandedSectionIndex = 8"
              >
                {{ sections[8].label }}
              </button>
            </h6>
            <h6>
              <span
                *ngIf="sections[8].completed"
                class="text-success ml-2"
                title="Completed"
                >&#10003;</span
              >
              <span
                *ngIf="!sections[8].completed"
                class="text-muted ml-2"
                title="Not completed"
                >&#9711;</span
              >
            </h6>
          </div>
        </div>
        <div
          [ngClass]="{
            collapse: expandedSectionIndex !== 8,
            show: expandedSectionIndex === 8
          }"
        >
          <div class="card-body">
            <ng-container *ngIf="mustCreateContractorType">
              <h6>
                In order for this workflow to work properly, there must be at
                least one Contractor Type in your jurisdiction. Please Save For
                Later and set up a Contractor Type.
              </h6>
            </ng-container>
            <ng-container *ngIf="!mustCreateContractorType">
              <div
                class="mb-4 border p-5 rounded"
                *ngFor="
                  let contractorSelectionActivity of config
                    .selectContractorUpdates.contractorSelectionActivities
                "
              >
                <div class="row">
                  <div class="col-md-12">
                    <h4>{{ contractorSelectionActivity.model.screenName }}</h4>
                  </div>
                  <div class="col-md-12">
                    <wm-contractor-selection-activity-editor
                      *ngIf="expandedSectionIndex === 8"
                      [activity]="contractorSelectionActivity"
                      [form]="
                        contractorUpdatesForm.controls[
                          contractorSelectionActivity.id
                        ]
                      "
                      [targetClientId]="targetJurisdictionId"
                    ></wm-contractor-selection-activity-editor>
                  </div>
                </div>
              </div>
              <div
                class="mb-4 border p-3 rounded"
                *ngFor="
                  let scDE of config.selectContractorUpdates
                    .selectContractorDataEntities
                "
              >
                <div class="row">
                  <div class="col-md-12">
                    <h3>{{ scDE.label }}</h3>
                  </div>
                  <div class="col-md-12">
                    <wm-select-contractor-data-entity-editor
                      *ngIf="expandedSectionIndex === 8"
                      [form]="contractorUpdatesForm.controls[scDE.templateCode]"
                      [dataEntity]="scDE"
                      [targetClientId]="targetJurisdictionId"
                    ></wm-select-contractor-data-entity-editor>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <button
                  class="btn btn-raised"
                  [disabled]="isSaving"
                  (click)="isSaving = true; saveForLater()"
                >
                  Save for Later
                </button>
                <button
                  class="btn btn-primary btn-raised"
                  [disabled]="
                    isSaving ||
                    (!isGlobalAdmin && contractorUpdatesForm.invalid)
                  "
                  (click)="
                    isSaving = true;
                    config.selectContractorUpdates.completed = true;
                    nextSection()
                  "
                >
                  Next
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Section 9: Select Map Service -->
      <div class="card" *ngIf="sections[9].enabled">
        <div class="card-header" id="headingMapService">
          <div class="d-flex justify-content-between">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                [attr.aria-expanded]="expandedSectionIndex === 9"
                (click)="expandedSectionIndex = 9"
              >
                {{ sections[9].label }}
              </button>
            </h5>
            <span
              *ngIf="sections[9].completed"
              class="text-success ml-2"
              title="Completed"
              >&#10003;</span
            >
            <span
              *ngIf="!sections[9].completed"
              class="text-muted ml-2"
              title="Not completed"
              >&#9711;</span
            >
          </div>
        </div>
        <div
          [ngClass]="{
            collapse: expandedSectionIndex !== 9,
            show: expandedSectionIndex === 9
          }"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div [formGroup]="mapServiceForm">
                  <label
                    >Select a Map Service:
                    <span class="text-danger">*</span></label
                  >
                  <select
                    class="form-control mb-2"
                    [(ngModel)]="config.mapServiceConfiguration.targetId"
                    formControlName="mapServiceTargetId"
                  >
                    <option
                      *ngFor="let tMapService of targetResources.mapServices"
                      [ngValue]="tMapService.id"
                    >
                      {{ tMapService.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <button
                class="btn btn-raised"
                [disabled]="isSaving"
                (click)="isSaving = true; saveForLater()"
              >
                Save for Later
              </button>
              <button
                class="btn btn-primary btn-raised"
                [disabled]="
                  isSaving || (!isGlobalAdmin && mapServiceForm.invalid)
                "
                (click)="
                  isSaving = true;
                  config.mapServiceConfiguration.completed = true;
                  nextSection()
                "
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-4 row d-flex justify-content-between">
        <div class="col ml-3">
          <h6>
            <strong>
              <div
                class="text-warning mt-1"
                *ngIf="!allSectionsCompleted && !isSaving"
              >
                All above sections must be completed before finishing this
                {{
                  config.action == WorkflowConfigurationSaveAction.Import
                    ? 'import'
                    : 'copy'
                }}
                process.
              </div>
              <ng-container *ngTemplateOutlet="blockersTmpl"></ng-container>
              <div
                class="text-success mt-1"
                *ngIf="allSectionsCompleted && blockers.length == 0"
              >
                All needed settings and configurations have been made. Click
                Finish to
                {{
                  config.action == WorkflowConfigurationSaveAction.Import
                    ? 'import'
                    : 'copy'
                }}
                this workflow.
              </div>
            </strong>
          </h6>
        </div>

        <div class="footer">
          <wm-common-button
            (click)="saveForLater()"
            [data]="{
              text: 'Save for Later',
              type: 'secondary'
            }">
          </wm-common-button>
          <div class="import-workflow-modal-blue-btn">
            <wm-common-button

              [disabled]="!allSectionsCompleted"
              (click)="openFinishConfirmationModal()"
              [data]="{
                text: 'Finish',
                type: 'primary'
              }">
            </wm-common-button>
          </div>
        </div>

        <!-- <div class="col-auto ms-auto">
          <button
            class="btn btn-raised"
            [disabled]="isSaving"
            (click)="isSaving = true; saveForLater()"
          >
            Save for Later
          </button>
        </div>
        <div class="col-auto">
          <wm-modal-confirm
            #finishModal
            [title]=finishText
            buttonText="Finish"
            commandText="Yes"
            [showButton]="true"
            [showButtonText]="true"
            [enabled]="
              !isSaving &&
              (isGlobalAdmin || (allSectionsCompleted && blockers.length == 0))
            "
            [closeOnAccept]="false"
            (accepted)="isProcessing = true; finish()"
          >
            <ng-container *ngIf="isProcessing">
              Please wait while your new workflow is being built! Depending on
              the options, this could take up to a minute.
              <app-loader></app-loader>
            </ng-container>
            <ng-container *ngIf="!isProcessing">
              <p
                *ngIf="
                  isGlobalAdmin &&
                  (!allSectionsCompleted || blockers.length > 0)
                "
                class="text-warning"
              >
                Because you are a System (Global) Administrator, you have the
                ability to copy/import workflows without completing all
                configurations or establishing needed data configurations in the
                jursidction. Proceeding without addressing these issues now will
                result in workflow validation errors that will need addressed in
                the destination workflow.
              </p>
              <p>
                This will finish the workflow configuration and import this
                workflow into your jurisdiction.
              </p>
              <p>Do you want to continue?</p>
            </ng-container>
          </wm-modal-confirm>
        </div> -->
      </div>
    </div>
  </div>
</ng-container>

<div class="modal-width">
  <wm-common-confirmation-modal [data]="finishModal" (onYesClick)="finish()"
    (onNoClick)="finishModal.open=false" [isApplicantMobileview]="true" (onCloseClick)="finishModal.open=false">
    <wm-common-text
      [data]="{
        text: 'This will finish the workflow configuration and import this workflow into your jurisdiction.'
      }"
    ></wm-common-text>
    <wm-common-text
      [data]="{
        text: 'Do you want to continue?'
      }"
    ></wm-common-text>
  </wm-common-confirmation-modal>
</div>

<ng-template #blockersTmpl>
  <div class="text-danger mt-1" *ngIf="blockers.length > 0">
    The following data must be configured in your jurisdiction before this
    {{
      config.action == WorkflowConfigurationSaveAction.Import
        ? 'import'
        : 'copy'
    }}
    process can be completed:
    <ul>
      <li *ngFor="let blocker of blockers">
        {{ blocker }}
      </li>
    </ul>
  </div>
</ng-template>
